import { z } from 'zod';

export const pushEndpointSchema = z.string().url().max(2048).refine((value) => {
  let url: URL;
  try { url = new URL(value); } catch { return false; }
  return url.protocol === 'https:' && !url.username && !url.password && (!url.port || url.port === '443') && (
    url.hostname === 'fcm.googleapis.com' || url.hostname === 'web.push.apple.com' ||
    url.hostname.endsWith('.push.services.mozilla.com') || url.hostname.endsWith('.notify.windows.com')
  );
}, 'Unsupported push service endpoint');

export const pushSubscriptionSchema = z.object({
  endpoint: pushEndpointSchema,
  keys: z.object({
    p256dh: z.string().min(80).max(100).regex(/^[A-Za-z0-9_\-=]+$/),
    auth: z.string().min(20).max(32).regex(/^[A-Za-z0-9_\-=]+$/),
  }),
});

export type PushSubscriptionInput = z.infer<typeof pushSubscriptionSchema>;

export const subscribeToNotificationsInputSchema = z.object({
  subscription: pushSubscriptionSchema,
});

export type SubscribeToNotificationsInput = z.infer<typeof subscribeToNotificationsInputSchema>;

export const unsubscribeFromNotificationsInputSchema = z.object({
  endpoint: pushEndpointSchema,
});

export type UnsubscribeFromNotificationsInput = z.infer<
  typeof unsubscribeFromNotificationsInputSchema
>;
